import PartnerDirectory from "../components/PartnerDirectory";
import { HardHat, Hammer, Truck, ClipboardCheck } from "lucide-react";

const FEATURES = [
    { icon: HardHat, title: "Full Construction", desc: "Independent bungalows, row houses, plots, farmhouses, boundary walls — with RCC, brickwork, plaster, POP." },
    { icon: Hammer, title: "Renovation & Extension", desc: "Additional floors, kitchen/bath overhauls, structural repairs, waterproofing and paintwork with warranty." },
    { icon: Truck, title: "Material Sourcing", desc: "GST-billed cement, TMT bars, sand, gravel and tile procurement at trade rates — pass-through pricing." },
    { icon: ClipboardCheck, title: "Approvals & QA", desc: "NMC/MahaRERA approvals, structural audit, third-party quality checks and on-site engineer supervision." },
];

export default function CivilContractors() {
    return (
        <PartnerDirectory
            role="civil_contractor"
            roleLabel="Civil Contractors"
            roleLabelSingular="Civil Contractor"
            path="/civil-contractors"
            heroTag="Construction & Renovation"
            heroTitle={<>Build with contractors who <span className="text-gold-500">finish on time.</span></>}
            heroSubtitle="Verified civil contractors with proven delivery records — transparent BOQs, milestone-linked payments and 10-year structural warranty on every project."
            features={FEATURES}
            jsonLdCategory="GeneralContractor"
        />
    );
}
